/* LADDOM product rail controller — Module 14.
   ~60 lines instead of a 140kb carousel library. */
(function () {
  'use strict';

  function initRail(section) {
    var track = section.querySelector('[data-rail-track]');
    if (!track || track.dataset.railReady === '1') return;
    track.dataset.railReady = '1';

    var prev = section.querySelector('[data-rail-prev]');
    var next = section.querySelector('[data-rail-next]');
    var thumb = section.querySelector('[data-rail-thumb]');
    var arrows = section.querySelector('[data-rail-arrows]');
    var ticking = false;

    function overflows() {
      return track.scrollWidth > track.clientWidth + 4;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= max - 2;

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;

      if (thumb) {
        var frac = track.clientWidth / track.scrollWidth;
        thumb.style.width = Math.max(frac * 100, 8) + '%';
        var progress = max > 0 ? track.scrollLeft / max : 0;
        var travel = (1 - frac) * 100 * progress;
        thumb.style.transform = 'translateX(' + (travel / Math.max(frac, 0.08)) + '%)';
      }
    }

    // Hide the controls entirely when everything already fits.
    function evaluate() {
      var many = overflows();
      if (arrows) arrows.style.display = many ? '' : 'none';
      var bar = section.querySelector('[data-rail-progress]');
      if (bar) bar.style.display = many ? '' : 'none';
      sync();
    }

    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          sync();
          ticking = false;
        });
      },
      { passive: true }
    );

    function page(dir) {
      track.scrollBy({
        left: dir * track.clientWidth,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth',
      });
    }
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    window.addEventListener('resize', evaluate, { passive: true });
    evaluate();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.ld-rail').forEach(initRail);
  }

  if (window.Motion && window.Motion.register) {
    window.Motion.register(initAll);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
